var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHamburger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 24.9168C8.72521 24.9168 9.58333 24.0587 9.58333 23.0002C9.58333 21.9416 8.72521 21.0835 7.66667 21.0835C6.60812 21.0835 5.75 21.9416 5.75 23.0002C5.75 24.0587 6.60812 24.9168 7.66667 24.9168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4487 21.0835H15.2187C14.2236 21.0835 13.417 21.8901 13.417 22.8852V23.1152C13.417 24.1102 14.2236 24.9168 15.2187 24.9168H38.4487C39.4437 24.9168 40.2503 24.1102 40.2503 23.1152V22.8852C40.2503 21.8901 39.4437 21.0835 38.4487 21.0835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4483 30.6665H7.55167C6.55663 30.6665 5.75 31.4731 5.75 32.4682V32.6982C5.75 33.6932 6.55663 34.4998 7.55167 34.4998H38.4483C39.4434 34.4998 40.25 33.6932 40.25 32.6982V32.4682C40.25 31.4731 39.4434 30.6665 38.4483 30.6665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4483 11.5H7.55167C6.55663 11.5 5.75 12.3066 5.75 13.3017V13.5317C5.75 14.5267 6.55663 15.3333 7.55167 15.3333H38.4483C39.4434 15.3333 40.25 14.5267 40.25 13.5317V13.3017C40.25 12.3066 39.4434 11.5 38.4483 11.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburger);
export default __webpack_public_path__ + "static/media/icon-hamburger.6198fed690220dbdc625ace240660292.svg";
export { ForwardRef as ReactComponent };